










































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { AsyncComputed } from '@/AsyncComputed';
import PromoNewsStore, { PromoNewsDetail, SystemCompanyNewsDetail } from '@/store/PromoNewsStore';
import AppStore from '@/store/App';
import MaterialCard from '@/components/material/Card.vue';
import DataRow from '@/components/material/DataRow.vue';
import Refreshable from '@/components/helper/Refreshable.vue';
import PromoNewsComposeDialog from '@/components/promo/PromoNewsComposeDialog.vue';
import ClipboardJS from 'clipboard';
import delay from 'delay';
import Axios from 'axios';

@Component({
    components: {
        MaterialCard,
        DataRow,
        Refreshable,
        PromoNewsComposeDialog,
    },
    metaInfo() {
        return { title: 'お知らせ詳細',
            backTo: '/promo/news'
        }
    }
})
export default class PromoNewsDetailView extends Vue {
    refreshing = false;
    showCompose = false;

    async mounted() {
        const id: number = parseInt(this.$route.params["id"]);
        if(PromoNewsStore.details[id] === undefined)
            await PromoNewsStore.updateDetail(id);
    }
    async refresh() {
        const id: number = parseInt(this.$route.params["id"]);

        this.refreshing = true;
        await Promise.all([delay(250), PromoNewsStore.updateDetail(id)]);
        this.refreshing = false;
    }

    @AsyncComputed({
        async get(this: PromoNewsDetailView) {
            const sid: number = parseInt(this.$route.params["id"]);
            return await PromoNewsStore.getDetail(sid);
        },
    })
    news: PromoNewsDetail = undefined as any;

    @AsyncComputed({
        async get(this: PromoNewsDetailView) {
            return this.news && this.news.companyNewsId
                ? await PromoNewsStore.getCompanyDetail(this.news.companyNewsId) : undefined;
        }
    })
    company_news: SystemCompanyNewsDetail = undefined as any;

    get preview_link() {
        return 'https://www.arrow-payment.com/news/' + this.$route.params["id"];
    }

    get photo_path() {
        return 'https://www.arrow-payment.com' + this.news.photo;
    }

    showCopySuccess() {
        AppStore.showSuccess('リンクをクリップボードにコピーしました。');
    }

    fileTest(val: FileList) {
        let formData = new FormData();
        formData.append('image', val[0]);

        Axios.post('/api/assets', formData);
    }

    async commit(key: string, value: any) {
        const nval = Object.assign({}, this.news);
        (nval as any)[key] = value;
        if(await PromoNewsStore.modifyDetail(nval)) {
            AppStore.showSuccess('データを正常に更新しました。');
        }
        else {
            AppStore.showError('データの更新中にエラーが発生しました。');
        }
    }

    async commitCompany(key: string, value: any) {
        const nval = Object.assign({}, this.company_news);
        (nval as any)[key] = value;
        if(await PromoNewsStore.modifyCompanyDetail(nval)) {
            AppStore.showSuccess('データを正常に更新しました。');
        }
        else {
            AppStore.showError('データの更新中にエラーが発生しました。');
        }
    }
}
